var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEmail = function SvgIconEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1666 15.168C12.8241 15.4025 12.4147 15.5195 12 15.5013C11.5852 15.5195 11.1758 15.4025 10.8333 15.168L2 10.418V18.8346C2 19.4977 2.26339 20.1335 2.73223 20.6024C3.20107 21.0712 3.83695 21.3346 4.49999 21.3346H19.5C20.163 21.3346 20.7989 21.0712 21.2677 20.6024C21.7366 20.1335 21.9999 19.4977 21.9999 18.8346V10.418L13.1666 15.168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.66797H4.50001C3.83697 4.66797 3.20108 4.93136 2.73224 5.4002C2.2634 5.86904 2.00001 6.50492 2.00001 7.16796V8.00129C1.99922 8.15156 2.03713 8.2995 2.11011 8.43087C2.18309 8.56223 2.28867 8.67258 2.41668 8.75129L11.5833 13.7513C11.7113 13.8186 11.856 13.8476 12 13.8346C12.144 13.8476 12.2887 13.8186 12.4167 13.7513L21.5833 8.75129C21.7113 8.67258 21.8169 8.56223 21.8899 8.43087C21.9628 8.2995 22.0008 8.15156 22 8.00129V7.16796C22 6.50492 21.7366 5.86904 21.2677 5.4002C20.7989 4.93136 20.163 4.66797 19.5 4.66797Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconEmail.780601c1.svg";
export { ForwardRef as ReactComponent };